// Some IIFE bundles (and their dependencies) assume Node-like globals exist.
// Provide a tiny runtime shim so the widget can run when embedded on customer sites.

const g = globalThis as any
const w = typeof window !== 'undefined' ? (window as any) : undefined
const host = w ?? g

if (!host.process || typeof host.process !== 'object') {
  host.process = { env: {} }
}

if (!host.process.env || typeof host.process.env !== 'object') {
  host.process.env = {}
}

if (!host.process.env.NODE_ENV) {
  host.process.env.NODE_ENV = 'production'
}

if (!host.global) {
  host.global = host
}

// Ensure both `window` and `globalThis` see the same values.
g.process = host.process
g.global = host.global
